export default function SyncableSectionBodyChangeController(
  pmSharedModelService
) {
  const vm = this;

  _activate();

  function _activate() {
    const bodyCurrent = vm.change.valueCurrent || '';
    const bodyTo = vm.change.valueTo || '';
    vm.change.tokenizedBody = pmSharedModelService.replaceTokens(bodyCurrent);
    vm.change.tokenizedNewBody = pmSharedModelService.replaceTokens(bodyTo);
    vm.change.breadcrumb = breadcrumb();
  }

  function breadcrumb() {
    if (vm.change.breadcrumbs === null) return null;
    return vm.change.breadcrumbs.join(' -> ');
  }
}

SyncableSectionBodyChangeController.$inject = [
  'pmSharedModelService',
];
